import styled from "styled-components";

export const StrongTextStyle = styled.span`
  font-weight: bold;
`;

export const LightTextStyle = styled.span`
  font-weight: normal;
`;

export const HighLightStyle = styled.span`
  color: #ffe606;
`;
